module.exports = __webpack_public_path__ + "static/media/logowhite.349b00bc.svg";